import React, { Component } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import { TextField } from "@material-ui/core";
import { getSimpleList } from "../crud/associado.crud";
import _ from "lodash";
import { listaStatus } from "../utils/Utils";

export default class AssociadoAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    onSearch = _.debounce((text) => {
        getSimpleList({ search_param: text, notificados: this.props.notificados ?? "", trazer_incompletos: this.props.trazer_incompletos ? true : "" }).then((res) => {
            this.setState({ data: res.data });
        });
    }, 500);

    textoInput = (value) => {
        return value ? `${value?.nome}${value?.documento ? ` - ${value?.documento}` : ""} - ${listaStatus.find((elemento) => String(elemento.value) === String(value?.ass_status))?.label ?? ""}` : "";
    };

    render() {
        const { setValue, value, disabled, touched, errors, required, label } = this.props;

        return <>{!disabled ? <Autocomplete className="select-tabela" loadingText={"Carregando..."} noOptionsText="Sem resultados." clearOnBlur={true} value={value} onChange={(_, value) => setValue(value)} onInputChange={(_, term) => this.onSearch(term)} onFocus={(event) => this.onSearch(event.target.value)} options={this.state.data} getOptionLabel={(option) => this.textoInput(option)} renderInput={(params) => <TextField {...params} label={label ?? `Associado` + (required ? " *" : "")} margin="normal" variant="outlined" helperText={touched && errors} error={Boolean(touched && errors)} />} /> : <TextField label={label ?? `Associado` + (required ? " *" : "")} margin="normal" variant="outlined" disabled value={this.textoInput(value)} />}</>;
    }
}
